import {
	colorsNew,
	ltSmMediaQuery,
} from 'root/src/client/web/commonStyles'

const styles = {
	backdrop: {
		position: 'fixed',
		maxWidth: '100%',
		maxHeight: '100%',
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		backgroundColor: 'rgba(0,0,0,0.2)',
		zIndex: 9999,
		display: 'flex',
		overscrollBehavior: 'contain',
		overflowY: 'auto',
	},
	modal: {
		overflowX: 'hidden',
		position: 'relative',
		zIndex: 101,
		flexDirection: 'column',
		maxWidth: '100%',
		margin: 'auto',
		borderRadius: 6,
		backgroundColor: colorsNew.dark3,
		display: 'flex',
		'& input': {
			color: '#ddd',
			backgroundColor: colorsNew.dark2,
			border: 'none',
		},
		[ltSmMediaQuery]: {
			width: '90%',
		},
	},
	sideSection: {
		width: 50,
		height: '100%',
		'@media (max-width: 360px)': {
			width: 0,

		},
	},
	modalNavButton: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		cursor: 'pointer',
		backgroundColor: 'transparent',
		border: 'none',
		padding: 0,
		top: 0,
		'@media (max-width: 425px)': {
			right: 0,
		},
	},
	backButtonIcon: {
		width: 26,
	},
	close: {
		width: 21,
		height: 21,
		marginTop: 11,
		marginRight: 11,
		padding: 0,
		backgroundColor: 'transparent',
		border: 'none',
		cursor: 'pointer',
	},
	contentContainer: { //
		display: 'flex',
		maxWidth: '100%',
		[ltSmMediaQuery]: {
			width: '100%',
		},
	},
	hide: {
		display: 'none',
	},
	container: {
		display: 'flex',
		maxWidth: '100%',
		[ltSmMediaQuery]: {
			width: '100%',
		},
	},
	content: {
		margin: 'auto',
		maxWidth: '100%',
		position: 'relative',
		padding: [[10, 30]],
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'center',
		'@media (max-width: 425px)': {
			padding: [[30, 0]],
			maxWidth: '90%',
		},
		[ltSmMediaQuery]: {
			width: '100%',
		},
	},
	title: {
		height: 24,
		fontFamily: 'Roboto',
		fontSize: 24,
		fontWeight: 'bold',
		lineHeight: 1.2,
		textAlign: 'center',
		color: '#ddd',
		marginBottom: 18,
	},
	text: {
		fontFamily: 'Roboto',
		fontSize: 16,
		lineHeight: 1.2,
		textAlign: 'center',
		color: '#ddd',
		marginBottom: 20,
		maxWidth: '100%',
	},
	modalActionButtons: {
		margin: [[5, 0]],
		display: 'flex',
		width: '100%',
		justifyContent: 'space-between',
		flexDirection: 'row-reverse',
	},
}

export default styles
